<script lang="ts">
import type { PrimitiveProps } from '@/Primitive'

export interface RangeCalendarHeaderProps extends PrimitiveProps {}
</script>

<script setup lang="ts">
import { Primitive } from '@/Primitive'

const props = withDefaults(defineProps<RangeCalendarHeaderProps>(), { as: 'div' })
</script>

<template>
  <Primitive v-bind="props">
    <slot />
  </Primitive>
</template>
